import Uri from 'jsuri';

const isMamaApp = () => {
    const ua = window.navigator.userAgent;
    return (
        /mmq/i.test(ua) ||
        /gzq/i.test(ua) ||
        /pregnancyhelper/i.test(ua) ||
        /recordapp/i.test(ua) ||
        /mmgoods/i.test(ua)
    );
};

export function getHrefQueryParamValue(key) {
    return new Uri(window.location.href).getQueryParamValue(key);
}

export function getBaseConfig() {
    return {
        sourceQueryParam: 'source',
        context_type: ''
    };
}

export function noop() {
    return void 0;
}

export function isIOS12() {
    return window.navigator.userAgent.indexOf('iPhone OS 12') > -1;
}

export default {
    isMamaApp: isMamaApp(),
    isAndroid() {
        const ua = window.navigator.userAgent;
        return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    },
    isArray(array) {
        return Object.prototype.toString.call(array) === '[object Array]';
    },
    isString(string) {
        return Object.prototype.toString.call(string) === '[object String]';
    },
    isIOS12: isIOS12()
};
